<template>
  <main class="orange-repayment">
    <div class="apply-mine">
      <p class="orange-title">全部借款</p>
      <el-tabs v-model="activeName">
        <el-tab-pane name="unRepay">
          <order-list
            v-if="activeName === 'unRepay'"
            @openAdvanceRepayDialog="advanceRepayment"
            @openRepayPlanDialog="repaymentPlan"
            @checkDetail="checkDetail"
          />
        </el-tab-pane>
        <!-- <el-tab-pane label="已还" name="repaid">
          <order-list v-if="activeName==='repaid'"></order-list>
        </el-tab-pane>
        <el-tab-pane label="全部" name="all">
          <order-list v-if="activeName==='all'"></order-list>
        </el-tab-pane> -->
      </el-tabs>
    </div>
    <el-dialog :visible.sync="loan.showDialog" :width="dialogWidth">
      <repaymentPlanDialog v-if="repaymentDialogFlag" />
      <!--还款计划弹窗-->
      <advanceRepaymentDialog v-if="advanceDialogFlag" />
      <loadDetail :loanOrderId="loanOrderId" v-if="loanDetailDialogFlag" />

      <!-- <div slot v-if="alertDialogFlag">每日14:00前可以申请当前的提前还款,请明天再试</div> -->
      <div class="title" slot="title">
        <i
          :class="{
            'info-icon': advanceDialogFlag,
            'el-icon-warning': advanceDialogFlag,
          }"
        ></i
        >{{ dialogTitle }}
      </div>
      <div slot="footer" class="dialog-footer" v-if="advanceDialogFlag">
        <el-button @click="closeDialog()">取 消</el-button>
        <el-button type="primary" @click="confirm()">确 定</el-button>
      </div>
      <!-- <div slot="footer" class="dialog-footer" v-if="alertDialogFlag">
        <el-button type="primary" class="kn-btn" @click="closeDialog()">知道了</el-button>
      </div> -->
    </el-dialog>
  </main>
</template>
<script>
import repaymentPlanDialog from '../../../components/orange-loan/repayment/repayment-plan.vue'
import advanceRepaymentDialog from '../../../components/orange-loan/repayment/advance-repayment.vue'
import orderList from '../../../components/orange-loan/repayment/repayment-list.vue'
import loadDetail from '../../../components/orange-loan/repayment/loan-detail.vue'
import { setTimeout } from 'timers'
import { mapState } from 'vuex'
export default {
  components: {
    repaymentPlanDialog,
    advanceRepaymentDialog,
    orderList,
    loadDetail,
  },
  data() {
    return {
      // showDialog: false,
      dialogTitle: '',
      dialogType: '',
      repaymentDialogFlag: false,
      advanceDialogFlag: false,
      loanDetailDialogFlag: false,
      timeFlag: true,
      activeName: 'unRepay',
      assetsId: '',
      loanOrderId: '',
      loanDetail: '',
      dialogWidth: '',
    }
  },
  computed: {
    ...mapState('loan', ['advanceRepayQuery', 'showDialog']),
    loan() {
      return this.$store.state.loan
    },
  },
  methods: {
    repaymentPlan() {
      // 打开还款计划弹窗
      this.repaymentDialogFlag = true
      this.advanceDialogFlag = false
      this.loanDetailDialogFlag = false
      this.dialogTitle = '还款计划'
      this.dialogWidth = '40%'
    },
    checkDetail(loanOrderId) {
      // 查看详情弹窗
      this.repaymentDialogFlag = false
      this.advanceDialogFlag = false
      this.loanDetailDialogFlag = true
      this.dialogTitle = '借款单详情'
      this.loanOrderId = loanOrderId
      this.dialogWidth = '50%'
    },
    advanceRepayment(item) {
      // 打开提前还款对话框
      this.advanceDialogFlag = true
      this.repaymentDialogFlag = false
      this.loanDetailDialogFlag = false
      this.dialogTitle = '您确认要提前还款吗?'
      this.loanOrderId = item.loanOrderId
      this.dialogWidth = '40%'
    },
    closeDialog() {
      // 关闭dialog
      this.$store.commit('loan/update', {
        showDialog: false,
      })
    },
    confirm() {
      if (this.advanceDialogFlag) {
        // 如果是提前还款
        this.$request({
          url: 'oneCar/api/advance/repay/trial/apply',
          method: 'post',
          data: {
            loanOrderId: this.loanOrderId,
            ...this.advanceRepayQuery.data,
          },
        }).then((res) => {
          if (!res.errorCode) {
            //还款成功
            this.$message({
              message: '提前还款申请提交成功',
              type: 'success',
            })
          } else {
            this.$message.error(res.errorMsg)
          }
        })
      }
      this.$store.commit('loan/update', {
        showDialog: false,
      })
    },
  },
}
</script>
<style lang="stylus">
@import '../../../assets/css/common-color.styl'
.orange-repayment
  .el-tabs
    margin-top -15px
  .el-dialog__title
    font-size 20px
  .el-icon-warning
    padding-right 8px
    font-size 28px
    line-height 28px
  .title
    display flex
    align-items center
    padding-bottom 24px
    line-height 1
    font-size 20px
    font-family PingFangSC-Medium
    color gray01
  .info-icon
    color primary-color
  .alert-info
    color #FC9153
  .kn-btn
    width 120px
  .apply-mine
    background #fff
    min-height calc(100vh - 180px)
    // min-height calc(100% - 64px)
    padding 32px
    .el-tabs__item
      font-family PingFangSC-Medium
    .orange-title
      line-height 20px
      font-size 20px
      color gray01
      font-weight 500
      font-family PingFangSC-Medium
    .el-tabs
      .el-tabs__header
        margin 0px
      .el-tabs__content
        position static
        padding-bottom 24px
    .el-dialog__wrapper
      .el-dialog
        width 1000px
        .el-dialog__header
          padding 0px
          .el-dialog__headerbtn
            top 13px
            display none
</style>
